module.exports = __webpack_public_path__ + "media/images/landing/fliist-logo-retina-704dba1ece4c8518df1884d5d0481dbb.png";